module.exports = __webpack_public_path__ + "static/media/argent.f5256c57.svg";